import { Box } from '@mui/material';
import Header from '../components/layout/Header';
import Hero from '../components/sections/Hero';
import Partners from '../components/sections/Partners';
import Products from '../components/sections/Products';
import Process from '../components/sections/Process';
import WhySoriSori from '../components/sections/WhySorisori';
import BroadcastMoments from '../components/sections/BroadcastMoments';
import CtaBanner from '../components/sections/CtaBanner';
import Footer from '../components/layout/Footer';

export default function Home() {
  return (
    <Box>
      <Header />
      <Hero />
      <Partners />
      <BroadcastMoments />
      <Products />
      <Process />
      <WhySoriSori />
      <CtaBanner />
      <Footer />
    </Box>
  );
}
